import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { createMarkup } from 'tools/WebTool';
import SelectBox from 'components/SelectBox';
import NoListText from 'components/NoListText';
import CategoryButtonComponent from '../CategoryButtonComponent';
import { ServiceContentsList } from 'pages/ServiceCenter/NoticeTab/style';
import { NoListTextTitle } from 'pages/ServiceCenter/QnATab/style';
import { TitleText, TitleBox, SelectWrapper } from './style';

const SearchCategorySection = ({
  faqCategoryList,
  onClickCategoryBtn,
  selectedCategoryCd,
  findValue,
  faqList = [],
  mallList = [],
  onChangeMall = () => {},
  selectedMallSeq = '',
}) => {
  const navigate = useNavigate();

  const selectedCategoryCdName = faqCategoryList.find(
    item => item.code === selectedCategoryCd
  )?.codeName;

  const setTitle = title => {
    if (!!findValue && title.indexOf(findValue) !== -1) {
      return title.replaceAll(findValue, `<strong>${findValue}</strong>`);
    }
    return title;
  };

  return (
    <>
      <CategoryButtonComponent
        categoryList={faqCategoryList}
        onClickCategoryBtn={onClickCategoryBtn}
        selectedCategoryCd={selectedCategoryCd}
      />
      <TitleBox>
        <TitleText>
          {selectedCategoryCdName || `'${findValue}' 검색 결과` || ''}
        </TitleText>
        {selectedCategoryCd === 'FAQ120' && (
          <SelectWrapper>
            <SelectBox
              optionList={mallList}
              optionHandleChange={onChangeMall}
              name="selectMall"
              value={selectedMallSeq}
              isNotDisabled={true}
              noPadding={true}
              $gray
            />
          </SelectWrapper>
        )}
      </TitleBox>
      {faqList.length > 0 ? (
        <ServiceContentsList>
          {faqList.map((item, index) => {
            return (
              <li
                key={`FoldedCard_${item.faqSeq}_${index}`}
                onClick={() => {
                  navigate(`${item.faqSeq}`);
                }}
              >
                <span className="questionMark">Q </span>
                <div className="textBox">
                  <span
                    className="titleRow"
                    dangerouslySetInnerHTML={createMarkup(
                      setTitle(item.subject)
                    )}
                  />
                  <div className="descriptionRow">
                    {item.classificationCdNm}
                    {item.mallNm && `| ${item.mallNm} `}
                  </div>
                </div>
                <div className="iconWrap">
                  <FeatherIcon
                    icon="chevron-right"
                    stroke="#02A4FF"
                    size={24}
                  />
                </div>
              </li>
            );
          })}
        </ServiceContentsList>
      ) : !!selectedCategoryCd ? (
        <NoListTextTitle>
          등록된 {selectedCategoryCdName}
          {selectedCategoryCdName === '기타' ? '가' : '이'} 없습니다.
        </NoListTextTitle>
      ) : (
        <NoListText
          title={`검색 결과가 없습니다.\n띄어쓰기나 맞춤법을 확인 후\n다시 한번 검색해 보세요.`}
          description=""
          border
        />
      )}
    </>
  );
};

export default SearchCategorySection;
